import { render, staticRenderFns } from "./DataMedicalEquipment.vue?vue&type=template&id=98b51808&"
import script from "./DataMedicalEquipment.vue?vue&type=script&lang=js&"
export * from "./DataMedicalEquipment.vue?vue&type=script&lang=js&"
import style0 from "./DataMedicalEquipment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports